module.exports = __webpack_public_path__ + "assets/img/share.8c429735.png";